module.exports = __webpack_public_path__ + "media/smart_sales/house_de-bcbcfe06.webp";